import RightArrow from '@atoms/RightArrow';
import { Text, View } from '@components/primitives';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import colors from '@theme/colors';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import styles from './styles';

type Region = {
  id: number;
  title: string;
};

type ProductConfig = {
  accountInput?: {
    fetchRegions?: boolean;
  };
};

type Props = {
  setSelectedPDAMRegion?: (region: { id: number; name: string }) => void;
  productConfig?: ProductConfig;
  regionsData?: Region[];
};

const BPDropdownWithRegions: React.FC<Props> = ({
  setSelectedPDAMRegion = () => {},
  productConfig = { accountInput: { fetchRegions: false } },
  regionsData = [{ id: 1, title: '' }],
}) => {
  const { t } = useTranslation('common');
  const navigation = useNavigation<any>();

  const [selectedRegion, setSelectedRegion] = useState<{ id: number; name: string }>({
    id: -1,
    name: '',
  });

  const fetchRegions = productConfig?.accountInput?.fetchRegions ?? false;

  useEffect(() => {
    if (selectedRegion.id !== -1) {
      setSelectedPDAMRegion(selectedRegion);
    }
  }, [selectedRegion]);

  if (!fetchRegions) return null;

  return (
    <View>
      <Text style={styles.txtSelectRegionHeader} variant="sm-normal" color={colors.neutral.darkMist}>
        {t('bp.selectRegionHeader')}
      </Text>
      <TouchableOpacity
        testID="btnRegionsNavigate"
        onPress={() => {
          navigation.navigate(navigationConstants.GG_REGIONS, {
            regionsData,
            setSelectedRegion,
          });
        }}
        style={styles.btnRegionStyles}>
        <Text
          variant="md-normal"
          color={selectedRegion.id === -1 ? colors.neutral.darkMist : colors.neutral.charcoal}
          flex={1}>
          {selectedRegion.id === -1 ? t('bp.selectRegion') : selectedRegion.name}
        </Text>
        <RightArrow />
      </TouchableOpacity>
    </View>
  );
};

export default React.memo(BPDropdownWithRegions);
